export enum Util {
  dateFormat = 'MM/dd/yyyy',
  serverPageSize = 2000,
  uiPageSize = 5000,
  CHUNK_SIZE = 1000,
  timeout = 30000,
  MAX_ALLOWED_EMAIL_ITEMS = 4,
  shortYes = 'Y',
  shortNo = 'N',
  yes = 'Yes',
  no = 'No',
  true = 'True',
  false = 'False',
  gross = 'G',
  net = 'N',
  accessorial = 'A',
  totalCharge = 'T',
  totalRevenue = 'R',
  fuelSurcharge = 'F',
  created = 'Created',
  ok = 'Ok',
  validated = 'Validation errors found',
  unexpected = 'Unexpected error',
  serverError = 'Server error',
  notFound = 'Not Found',
  exists = 'Already Exists',
  duplicate = 'Duplicate Input Entry',
  rejectedCd = 'R',
  all = 'ALL',
  failCd = 'FAIL',
  retry = 'RETRY_CREATE',
  formSent = 'SENT',
  formUnsent = 'UNSENT',
  textWarning = 'text-warning',
  textDanger = 'text-danger',
  textSuccess = 'text-success',
  invalidCommentMessage = 'Only alpha-numeric and the following special characters are allowed $ @ % ( ) & + - / . , =',
  shipmentFlagTooltip = 'Shipment is discounted with $0 Owed amount',
  DefaultDate = '12/31/2999',
}
